const Intro = () => {
  return (
    <div id="intro" className="intro">
      <div>
        <div className="container-sm text">
          <div className="text-start">
            <p className="p1">"기존의 제도와 틀에 안주하지 않고 변화와 혁신을 통한 아미소프트의 미래가치를 창출할 수 있도록 스스로 끊임없이 도전할 것입니다."</p>
            <p className="mt-4 p2">
              교량관리시스템(BMS), 통합계측시스템(IMS), SI 프로젝트 등 전문성을 기반으로 다양한 분야에서 풍부한 경험을 축적하고 있으며, 이러한 경험으로부터 얻은 살아있는 지식을 고객에게 되돌려 주기 위해 항상 최선을 다하는 기업으로 고객의 성실한 협력자로 자리매김 하고자 합니다. 또한 신뢰를 중시하며
              당사가 공급하는 제품에 대해서는 끝까지 책임을 지는 책임 있는 경영을 기본이념으로 합니다. 하루가 다르게 발전하는 관련 기술을 적극적으로 받아들이고 보다 앞선 기술, 세련된 작품을 개발함으로써 분야 최고의 기업을 향해 나아가고 있습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
